// Autocomplete producto - Sprint 32 (compartido clientes/ventas).
import { useEffect, useRef, useState } from 'react';
import apiClient from '../../api/apiClient';

export default function ProductPickerLite({ value, onPick, placeholder = 'Buscar producto...' }) {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const tRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    if (tRef.current) clearTimeout(tRef.current);
    tRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({ q: q || '' });
        const r = await apiClient.get('/productos/search?' + params.toString());
        setItems((r && r.data && r.data.items) || []);
      } catch (e) { setItems([]); } finally { setLoading(false); }
    }, 250);
    return () => { if (tRef.current) clearTimeout(tRef.current); };
  }, [q, open]);

  const pick = (p) => {
    onPick(p);
    setQ('');
    setOpen(false);
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={q}
        onFocus={() => setOpen(true)}
        onChange={(e) => { setQ(e.target.value); setOpen(true); }}
        placeholder={placeholder}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
      />
      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white rounded-lg border border-gray-200 shadow-lg max-h-72 overflow-y-auto">
          {loading && <div className="p-3 text-xs text-gray-400">Buscando...</div>}
          {!loading && items.length === 0 && (
            <div className="p-3 text-xs text-gray-400">Sin resultados.</div>
          )}
          {!loading && items.map((p) => (
            <button key={p.id} type="button" onClick={() => pick(p)}
              className="block w-full text-left px-3 py-2 text-sm hover:bg-blue-50">
              <div className="font-medium text-gray-900">{p.nombre || p.name}</div>
              <div className="text-[11px] text-gray-500">
                {p.sku ? 'SKU ' + p.sku + ' · ' : ''}
                Stock: {p.stock ?? '—'} · Precio: {p.precio_venta ?? p.sale_price ?? '—'}
              </div>
            </button>
          ))}
          <button type="button" onClick={() => setOpen(false)}
            className="block w-full text-center px-3 py-1.5 text-[11px] text-gray-400 border-t border-gray-100 hover:bg-gray-50">
            Cerrar
          </button>
        </div>
      )}
    </div>
  );
}
